
import { supabase } from '../../supabase';
import { PlatformStat } from '../types';
import { getPlatformCategory } from '../device/platformDetection';
import { AuthFilter } from '@/components/analytics/AuthFilterButtons';

/**
 * Get platform distribution statistics
 */
export const getPlatformStats = async (
  startDate: Date, 
  endDate: Date,
  authFilter: AuthFilter = 'all'
): Promise<PlatformStat[]> => {
  const { data, error } = await supabase.rpc('get_platform_stats_aggregated', {
    start_date: startDate.toISOString(),
    end_date: endDate.toISOString(),
    auth_filter: authFilter
  });
  
  if (error) {
    console.error('Error fetching platform stats:', error);
    throw error;
  }
  
  // Post-process platforms to apply capitalization and category logic
  const platformCounts: Record<string, number> = {};
  
  (data || []).forEach(item => {
    let platform = item.platform;
    
    // If platform is empty/unknown, try to categorize
    if (!platform || platform === 'Unknown' || platform === 'unknown') {
      platform = 'Unknown';
    } else {
      // Capitalize first letter for consistent display
      platform = platform.charAt(0).toUpperCase() + platform.slice(1);
    }
    
    platformCounts[platform] = (platformCounts[platform] || 0) + Number(item.count);
  });
  
  return Object.entries(platformCounts).map(([platform, count]) => ({
    platform,
    count
  }));
};
